import React from 'react'
import { Routes, Route, useLocation} from "react-router-dom"
import Profile from '../pages/profile/Profile';
import Skillspage from '../pages/skillspage/Skillspage';
import Projects from '../pages/projects/Projects'
import Project from '../pages/project/Project'
import Contact from '../pages/contact/Contact';
import Welcomepage from "../pages/welcomepage/Welcomepage"
import { AnimatePresence } from "framer-motion"
const AnimatedRoutes = () => {
    const location = useLocation()
  return (
    <AnimatePresence key={location.pathname} >
        <Routes>
            <Route path="/" element={<Welcomepage/>}/>
            <Route path="/profile" element={<Profile/>}/>
            <Route path="/skills" element={<Skillspage/>}/>
            <Route path="/projects" element={<Projects/>}/>
            <Route path="/project/:id" element={<Project/>}/>
            <Route path="/contact" element={<Contact/>}/>
        </Routes>
    </AnimatePresence>
  )
}

export default AnimatedRoutes